"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Marker = void 0;
var react_1 = __importStar(require("react"));
var ReactDOMServer = __importStar(require("react-dom/server"));
var context_1 = require("./context");
var useEventHandlers_1 = require("./useEventHandlers");
var get_dom_marker_icon_1 = __importDefault(require("./utils/get-dom-marker-icon"));
var get_marker_icon_1 = __importDefault(require("./utils/get-marker-icon"));
/**
 * A "normal" marker that uses a static image as an icon.
 * large numbers of markers of this type can be added to the map
 * very quickly and efficiently
 */
var Marker = function (_a) {
    var children = _a.children, _b = _a.group, group = _b === void 0 ? "default" : _b, bitmap = _a.bitmap, data = _a.data, _c = _a.draggable, draggable = _c === void 0 ? false : _c, lat = _a.lat, lng = _a.lng, anchor = _a.anchor, onTap = _a.onTap, onPointerEnter = _a.onPointerEnter, onPointerLeave = _a.onPointerLeave, onPointerMove = _a.onPointerMove, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, options = __rest(_a, ["children", "group", "bitmap", "data", "draggable", "lat", "lng", "anchor", "onTap", "onPointerEnter", "onPointerLeave", "onPointerMove", "onDrag", "onDragEnd", "onDragStart"]);
    var _d = (0, react_1.useContext)(context_1.HEREMapContext), map = _d.map, removeFromMarkerGroup = _d.removeFromMarkerGroup, addToMarkerGroup = _d.addToMarkerGroup;
    var _e = (0, react_1.useState)(null), marker = _e[0], setMarker = _e[1];
    var renderChildren = function () {
        if (!map) {
            throw new Error("Map has to be loaded before performing this action");
        }
        // if children are provided, we render the provided react
        // code to an html string
        var html = ReactDOMServer.renderToStaticMarkup((react_1["default"].createElement("div", { className: "dom-marker" }, children)));
        // we then get a dom icon object from the wrapper method
        return (0, get_dom_marker_icon_1["default"])(html);
    };
    var addMarkerToMap = function () {
        if (!map) {
            throw new Error("Map has to be loaded before performing this action");
        }
        var newMarker = null;
        if (react_1["default"].Children.count(children) > 0) {
            var icon = renderChildren();
            newMarker = new H.map.DomMarker({ lat: lat, lng: lng }, { icon: icon });
        }
        else if (bitmap) {
            // if we have an image url or an svg markup and no react children, create a
            // regular icon instance
            var icon = (0, get_marker_icon_1["default"])(bitmap, anchor);
            // then create a normal marker instance and attach it to the map
            newMarker = new H.map.Marker({ lat: lat, lng: lng }, __assign({ icon: icon, 
                // @ts-ignore
                volatility: draggable }, options));
        }
        else {
            // create a default marker at the provided location
            newMarker = new H.map.Marker({ lat: lat, lng: lng });
        }
        newMarker.draggable = draggable;
        newMarker.setData(data);
        addToMarkerGroup(newMarker, group);
        setMarker(newMarker);
        return newMarker;
    };
    (0, useEventHandlers_1.useEventHandlers)(marker, {
        onDrag: onDrag,
        onDragEnd: onDragEnd,
        onDragStart: onDragStart,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onPointerMove: onPointerMove,
        onTap: onTap
    });
    (0, react_1.useEffect)(function () {
        var addedMarker = addMarkerToMap();
        return function () {
            removeFromMarkerGroup(addedMarker, group);
        };
    }, [group]);
    (0, react_1.useEffect)(function () {
        if (marker) {
            marker.draggable = draggable;
            // @ts-ignore
            marker.setVolatility(draggable);
        }
    }, [marker, draggable]);
    (0, react_1.useEffect)(function () {
        marker === null || marker === void 0 ? void 0 : marker.setGeometry({
            lat: lat,
            lng: lng
        });
    }, [marker, lat, lng]);
    (0, react_1.useEffect)(function () {
        marker === null || marker === void 0 ? void 0 : marker.setData(data);
    }, [marker, data]);
    (0, react_1.useEffect)(function () {
        if (bitmap) {
            marker === null || marker === void 0 ? void 0 : marker.setIcon((0, get_marker_icon_1["default"])(bitmap, anchor));
        }
    }, [marker, bitmap, anchor]);
    (0, react_1.useEffect)(function () {
        if (react_1["default"].Children.count(children)) {
            var icon = renderChildren();
            marker === null || marker === void 0 ? void 0 : marker.setIcon(icon);
        }
    }, [marker, children === null || children === void 0 ? void 0 : children.props]);
    return null;
};
exports.Marker = Marker;
exports["default"] = exports.Marker;
